<template>
  <Modal v-model="showModal"
    scrollable
    fullscreen
    :mask="true"
    :mask-closable="false"
    @on-cancel="closeModal"
    @submit="submit"
    title="编辑模板">
    <HtmlEditor
      :content="html"
      :dictionary="dictionary"
      @change="changeHtml"
      v-if="showModal" />
    <div slot="footer">
      <Button type="primary" @click="submit">提交</Button>
      <Button @click="closeModal">取消</Button>
    </div>
  </Modal>
</template>

<script>
import HtmlEditor from './HtmlEditor'
export default {
  name: 'html-editor-modal',
  props: {
    callback: Function,
    show: Boolean,
    content: String,
    dictionary: Array
  },
  components: {
    HtmlEditor
  },
  data () {
    return {
      showModal: false,
      html: null
    }
  },
  computed: {
  },
  watch: {
    show: function (newVal) {
      if (this.content) {
        this.html = this.content
      }
      this.showModal = newVal
    }
  },
  methods: {
    changeHtml (html) {
      this.html = html
    },
    closeModal () {
      this.showModal = false
      this.$emit('close-modal')
    },
    submit () {
      this.$emit('submit', this.html, this.callback)
      this.closeModal()
    }
  }
}
</script>

<style lang="less" scoped>
</style>
